const AVATAR_KEY = "pnl_user_avatar";
const USERNAME_KEY = "pnl_twitter_username";

export function readCachedProfileAvatar() {
  try {
    return localStorage.getItem(AVATAR_KEY) || "";
  } catch {
    return "";
  }
}

export function readCachedTwitterUsername() {
  try {
    return localStorage.getItem(USERNAME_KEY) || "";
  } catch {
    return "";
  }
}

export function writeProfileCache({ userAvatar, twitter_username } = {}) {
  try {
    if (userAvatar) localStorage.setItem(AVATAR_KEY, userAvatar);
    if (twitter_username) localStorage.setItem(USERNAME_KEY, twitter_username);
  } catch {
    // ignore quota / private mode
  }
}

export function clearProfileCache() {
  try {
    localStorage.removeItem(AVATAR_KEY);
    localStorage.removeItem(USERNAME_KEY);
  } catch {
    // ignore
  }
}

/** Warm HTTP cache for a remote avatar before the hero <img> mounts. */
export function prefetchProfileImageUrl(src) {
  if (!src || typeof src !== "string") return;

  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = src;
  link.referrerPolicy = "no-referrer";
  document.head.appendChild(link);

  const img = new Image();
  img.referrerPolicy = "no-referrer";
  img.decoding = "async";
  img.src = src;
}
